// Foundations
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

// rxjs
import { finalize } from 'rxjs/operators';

// Services
import { AnalyticsService } from 'src/app/services/analytics.service';
import { MyProfileService } from 'src/app/services/my-profile.service';
import { CamperCamsService } from 'src/app/services/camper-cams.service';
import { LoadingIndicatorService } from '../../services/loading-indicator.service';
import { HttpService } from '../../services/http.service';

interface CameraObject {
  display: string;
  value: string;
}

@Component({
  selector: 'app-camper-cams',
  templateUrl: './camper-cams.component.html',
  styleUrls: ['./camper-cams.component.scss'],
})
export class CamperCamsComponent implements OnInit {
  @Output() changeStep = new EventEmitter<number>();

  cameraList: CameraObject[];
  availableCamera = false;
  selectedUrl = '';
  inputControl = new FormControl();

  constructor(
    public myProfileService: MyProfileService,
    public camperCamsService: CamperCamsService,
    private _analytics: AnalyticsService,
    private loadingIndicatorService: LoadingIndicatorService,
    private httpService: HttpService
  ) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.myProfileService.fetchLocationList();
    this.fetchData();
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  changeCamperLocation() {
    this._analytics.logButtonTap('camperCams_changeCamperLocation');

    this.changeStep.emit(1);
    window.scroll(0,0);
  }

  onSelected(event) {
    this._analytics.logButtonTap('camperCams_changeCamperCamera');

    if (this.availableCamera) {
      this.selectedUrl = event.value;
    }
  }

  // Private Methods
  // ------------------------------------------------------------------------------------

  private fetchData(): void {
    this.loadingIndicatorService.show();

    this.httpService.getCampLocations().subscribe(
      (locationList: any[]) => {
        let hasMatchingCameras = false;
        const campCode = Number(
          this.camperCamsService.selectedLocation
            ? this.camperCamsService.selectedLocation.code
            : this.myProfileService.preferredLocation.code
        );
        for (const location of locationList) {
          const locationId = +location.id.split('-')[1];
          if (locationId === campCode) {
            hasMatchingCameras = true;
            // Fetch camper cams from location id
            this.httpService
              .getCampLocationCameras(location.id)
              .pipe(finalize(() => this.loadingIndicatorService.hide()))
              .subscribe(
                (camSrcList: any[]) => {
                  this.setValueList(camSrcList);
                },
                (e) => console.log(e)
              );
            break;
          }
        }
        // Empty state
        if (!hasMatchingCameras) {
          this.setValueList([]);
          this.loadingIndicatorService.hide();
        }
      },
      (e) => {
        console.log(e),
        this.loadingIndicatorService.hide();
      }
  );
  }

  private setValueList(campCamList): void {
    //
    const tempList = [];
    this.cameraList = [];

    //
    if (campCamList.length > 0) {
      campCamList.forEach((item, index) => {
        const camSrc = item.sourceV2.split(';', 2)[1];
        if (index === 0) {
          this.selectedUrl = camSrc;
        }
        tempList.push({
          display: item.name,
          value: camSrc,
        });
      });
    }

    // Check the empty state
    if (tempList.length === 0) {
      //
      this.availableCamera = false;
      // Create a dummy one
      this.cameraList = [
        {
          display: 'No available camera!',
          value: '',
        },
      ];
    } else {
      this.availableCamera = true;
      this.cameraList = tempList;
    }

    // Auto select the first one
    this.selectedUrl = this.cameraList[0].value;
    this.inputControl.setValue(this.cameraList[0].display);
  }
}
